import { createContext, useContext } from 'react'
import { type CrossClientQueryEvaluation, type CrossClientQueryResult } from '../../../../models/CrossClient'
import { type CcqCard } from './ccqResultView'

export const CcqAiBatchSteps = { IDLE: 'idle', RUNNING: 'running', RESULT: 'result' } as const

export type CcqAiBatchStep = (typeof CcqAiBatchSteps)[keyof typeof CcqAiBatchSteps]

export interface CcqAiBatch {
  step: CcqAiBatchStep
  clientCount: number
  movedToMatched: number
  movedToNotMatched: number
  movedToMissingData: number
  isStopping: boolean
}

export const IDLE_BATCH: CcqAiBatch = {
  step: CcqAiBatchSteps.IDLE,
  clientCount: 0,
  movedToMatched: 0,
  movedToNotMatched: 0,
  movedToMissingData: 0,
  isStopping: false,
}

export interface CcqAi {
  isChecking: (resultId: string) => boolean
  runClient: (result: CrossClientQueryResult, card: CcqCard) => Promise<void>
  batchFor: (card: CcqCard) => CcqAiBatch
  trackEvaluation: (evaluation: CrossClientQueryEvaluation, card: CcqCard, resultIds?: string[]) => void
  stopBatch: (card: CcqCard) => Promise<void>
}

export const CcqAiContext = createContext<CcqAi | null>(null)

export const useCcqAi = (): CcqAi => {
  const value = useContext(CcqAiContext)
  if (value === null) {
    throw new Error('useCcqAi must be used inside CcqAiProvider')
  }
  return value
}
